var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-nunito font-normal text-xl"},[_c('span',{staticClass:"font-bold"},[_vm._v(_vm._s(_vm.currentPage))]),_vm._v(" of "+_vm._s(_vm.totalPages)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }